import { render, staticRenderFns } from "./OnboardUserDetails.vue?vue&type=template&id=50bd438c&scoped=true&"
import script from "./OnboardUserDetails.vue?vue&type=script&lang=ts&"
export * from "./OnboardUserDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardUserDetails.vue?vue&type=style&index=0&id=50bd438c&lang=scss&scoped=true&"
import style1 from "./OnboardUserDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd438c",
  null
  
)

export default component.exports